/**
 * 401-herstel: verlengt automatisch de sessie met de refresh-cookie en
 * probeert de mislukte call opnieuw. Lukt dat niet, dan terug naar het loginscherm.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "hr_token";

let bezig = null;

export async function verniewToken() {
  if (!bezig) {
    bezig = axios
      .post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then((r) => {
        localStorage.setItem(TOKEN_KEY, r.data.token);
        axios.defaults.headers.common.Authorization = `Bearer ${r.data.token}`;
        return r.data.token;
      })
      .finally(() => { bezig = null; });
  }
  return bezig;
}

export function koppelAuthRetry(instance) {
  instance.interceptors.response.use(undefined, async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status !== 401 || cfg.__retried || url.includes("/auth/")) throw error;
    if (!localStorage.getItem(TOKEN_KEY)) throw error;
    try {
      const token = await verniewToken();
      cfg.__retried = true;
      cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${token}` };
      return instance.request(cfg);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.reload();
      throw error;
    }
  });
}
